import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'personDataBlock.title',
    defaultMessage: 'Person Data',
  },
  config: {
    id: 'personDataBlock.config',
    defaultMessage: 'Configuration',
  },
  layout: {
    id: 'personDataBlock.layout',
    defaultMessage: 'Card layout',
  },
  layoutDesc: {
    id: 'personDataBlock.layoutDesc',
    defaultMessage: 'Choose between vertical or horizontal card layout.',
  },
  cardType: {
    id: 'personDataBlock.cardType',
    defaultMessage: 'Card type',
  },
  summaryDesc: {
    id: 'personDataBlock.summaryDesc',
    defaultMessage: 'Displays the card in summary mode',
  },
  hideName: {
    id: 'personDataBlock.hideName',
    defaultMessage: 'Hide name',
  },
  showDescription: {
    id: 'personDataBlock.showDescription',
    defaultMessage: 'Show description',
  },
  showPersonLink: {
    id: 'personDataBlock.showPersonLink',
    defaultMessage: 'Clickable person name',
  },
  showPersonLinkDesc: {
    id: 'personDataBlock.showPersonLinkDesc',
    defaultMessage: 'If enabled, the person name becomes a link to their page.',
  },
  vertical: {
    id: 'personDataBlock.vertical',
    defaultMessage: 'Vertical',
  },
  horizontal: {
    id: 'personDataBlock.horizontal',
    defaultMessage: 'Horizontal',
  },
  normal: {
    id: 'personDataBlock.normal',
    defaultMessage: 'Normal',
  },
  summary: {
    id: 'personDataBlock.summary',
    defaultMessage: 'Summary card',
  },
});

export const personSchema = ({ intl, data }) => {
  return {
    title: intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.config),
        fields: [
          // 'layout',
          'summary',
          'showDescription',
          'hideName',
          'showPersonLink',
        ],
      },
    ],
    properties: {
      // layout: {
      //   title: intl.formatMessage(messages.layout),
      //   description: intl.formatMessage(messages.layoutDesc),
      //   type: 'string',
      //   choices: [
      //     ['vertical', intl.formatMessage(messages.vertical)],
      //     ['horizontal', intl.formatMessage(messages.horizontal)],
      //   ],
      //   default: 'vertical',
      // },
      summary: {
        title: intl.formatMessage(messages.summary),
        description: intl.formatMessage(messages.summaryDesc),
        type: 'boolean',
        default: false,
      },
      hideName: {
        title: intl.formatMessage(messages.hideName),
        type: 'boolean',
        default: false,
      },
      showDescription: {
        title: intl.formatMessage(messages.showDescription),
        type: 'boolean',
        default: false,
      },
      showPersonLink: {
        title: intl.formatMessage(messages.showPersonLink),
        description: intl.formatMessage(messages.showPersonLinkDesc),
        type: 'boolean',
        default: false,
        isDisabled: data?.hideName,
      },
    },
    required: [],
  };
};
